// extracted by mini-css-extract-plugin
module.exports =  {"container":"_6444e049b8--container--ktXmQ","link":"_6444e049b8--link--acwir","link-area":"_6444e049b8--link-area--bIF7s"};